import React, { useEffect, useRef, useState } from "react";
import { to } from "react-spring";
import useMousePosition from "./useMousePosition";
import useTimer from "./useTimer";

const useHover = (hoverDescription = <div></div>, showTime = 1) => {
  const timer = useTimer();
  const descriptionDiv = useRef(null);
  const [hover, setHover] = useState(false);
  const [hoverTime, setHoverTime] = useState({ start: 0, active: 0 });
  const [showDescription, setShowDescription] = useState(false);
  const [contentDimensions, setContentDimensions] = useState({
    width: null,
    height: null,
  });
  const mousePosition = useMousePosition();

  useEffect(() => {
    if (hover) {
      setHoverTime({ ...hoverTime, active: timer.tick });
      if (timer.tick - hoverTime.start >= showTime) setShowDescription(true);
      else setShowDescription(false);
    }
  }, [timer.tick]);

  useEffect(() => {
    if (hover) setHoverTime({ ...hoverTime, start: timer.tick });
    else {
      setShowDescription(false);
      setHoverTime({ start: 0, active: 0 });
    }
  }, [hover]);

  useEffect(() => {
    if (descriptionDiv.active) {
      let dimensions = {
        width: descriptionDiv.active.offsetWidth,
        height: descriptionDiv.active.offsetHeight,
      };
      setContentDimensions(dimensions);
    }
  }, [descriptionDiv, hover, showDescription]);
  return {
    divProps: {
      onMouseEnter: () => {
        setHover(true);
      },
      onMouseLeave: () => setHover(false),
    },
    hover,
    hoverDescription: (
      <div
        ref={descriptionDiv}
        style={{
          position: "fixed",
          left: `${mousePosition.x}px`,
          top: `${mousePosition.y - contentDimensions.height}px`,
        }}
      >
        {hover && showDescription && hoverDescription}
      </div>
    ),
  };
};

export default useHover;
